import store from "@/config/vuex/store";

export default [
    {
        path: "/empresas",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "empresasRead",
                component: () => import('@/pages/Empresa/EmpresaRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "cadastrar",
                name: "empresasCreate",
                component: () => import('@/pages/Empresa/EmpresaCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "editar/:id",
                name: "empresasUpdate",
                component: () => import('@/pages/Empresa/EmpresaUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "conveniadas",
                name: "empresasCoveniadasRead",
                component: () => import('@/pages/Empresa/EmpresaConveniadaRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
        ]
    }
]

